<script lang="ts" setup>
import Button from '@/components/core/Button.vue';
import Dialog, { DialogSize } from '@/components/core/Dialog.vue';

const props = defineProps<{
  size: DialogSize;
}>();

const emit = defineEmits<{
  (e: 'hide'): void;
  (e: 'cancel'): void;
  (e: 'switchToLiteMode'): void;
}>();

const handleSwitchToLiteMode = () => {
  emit('switchToLiteMode');
};

const handleCancel = () => {
  emit('cancel');
};
</script>

<template>
  <Dialog
    :title="$t('Lite Mode')"
    :showOverlay="false"
    v-bind="{ ...props }"
    @hide="emit('hide')"
    @close="emit('cancel')"
  >
    <div class="flex flex-col gap-y-4 p-4 text-themePrimaryTextColor">
      <p class="text-base">
        {{
          $t(
            `We’re having trouble connecting to the event stream. Would you like to switch to Lite Mode instead?`
          )
        }}
      </p>
      <div class="flex justify-between">
        <div class="flex gap-2">
          <Button
            id="connection-failed-dialog-continue-button"
            type="secondary"
            data-testid="connection-failed-continue"
            @click="handleSwitchToLiteMode"
          >
            {{ $t('Switch to Lite Mode') }}
          </Button>
          <button
            id="connection-failed-dialog-cancel-button"
            class="btn-text btn-primary-alt rounded-sm"
            data-testid="connection-failed-cancel"
            @click="handleCancel"
          >
            {{ $t('Cancel') }}
          </button>
        </div>
      </div>
    </div>
  </Dialog>
</template>
